import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../../utils/Seo";

const PrivacyPolicy = () => {
  return (
    <>
      <SEO
        title="Privacy Policy - MyAd360"
        description="Learn how MyAd360 handles your data with transparency and compliance in our privacy policy."
        keywords="MyAd360 privacy policy, user data, data protection, GDPR compliance"
      />

      <div className="paddingX py-9">
        <main className="relative overflow-hidden py-24">
          <div className="mx-auto container paddingX">
            <div className="tinymce-content">
              <h4 className="text-[24px] font-bold text-[#0d0c1b]">
                PrivacyPollicy
              </h4>
              <p>
                Following are the terms and conditions that govern your use of
                this Site (“Terms of Use”).
              </p>
              <p>
                Using this site tells us that you have read and agreed to our
                Terms of Use detailed below and our{" "}
                <Link className="text-green-400"> Privacy Policy.</Link> Please
                read the following sections carefully. If you do not agree with
                these terms, please exit this Web Site or any site affiliated with
                this Web Site. These Terms of Use apply to all web sites owned and
                operated by myad360. myad360 reserves the right to terminate
                Membership (defined below) and deny access to the Site to any
                person who violates these Terms of Use.
              </p>

              <h4 className="text-[24px] font-bold text-[#0d0c1b]">
                Future Changes
              </h4>
              <p>
                myad360 may change these Terms of Use, including our{" "}
                <Link className="text-green-400"> Privacy Policy.</Link>, upon
                notice, which may be given by posting such notice on the Web Site.
                However, in some cases, if in the reasonable view of myad360, a
                change to the Terms of Use or to our{" "}
                <Link className="text-green-400"> Privacy Policy.</Link>{" "}
                constitutes a material change, such a change will not take effect
                until 14 days after notice is provided, during which time you may
                notify us that you do not accept the change. Your continued use of
                the Web Site after such 14 day period will mean that you accept
                any such change. Although we may choose to notify you of changes
                by email or by other means, you agree that notice of changes to
                the Terms of Use and{" "}
                <Link className="text-green-400"> Privacy Policy.</Link> posted on
                the Web Site constitutes reasonable and sufficient notice.
              </p>
              <h4 className="text-[24px] font-bold text-[#0d0c1b]">
                Intellectual Property Rights
              </h4>
              <p>
                All information, content, services and software displayed on,
                transmitted through or used in connection with myad360 sites,
                including, but not limited to, news articles, reviews,
                directories, guides, text, photographs, images, illustrations,
                audio clips, video, html, source and object code, trademarks,
                logos and the like, as well as its selection and arrangement
                (together, the “Content), is owned by myad360 and its affiliated
                companies or the third party credited as the owner of the Content.
                You may use the Content online only, and solely for your personal,
                non-commercial use. If you operate a web site and wish to link to
                any of the sites owned and operated by myad360, you may do so
                provided you agree to cease such link upon request from myad360
                and that you do not state or imply any sponsorship of your site by
                myad360 (for example, by using our stylized trademark or logo). No
                other use is permitted without prior written
              </p>
              <p className="mt-4">
                permission of myad360. The permitted use described in this
                Paragraph is contingent on your compliance at all times with these
                Terms of Use.
              </p>
              <p className="mt-4">
                You may not, for example, republish any portion of the Content on
                any internet, intranet or extranet site or incorporate the Content
                in any database, compilation, archive or cache. You may not
                distribute any Content to others, whether or not for payment or
                other consideration, and you may not modify, copy, frame, cache,
                reproduce, sell, publish, transmit, display or otherwise use any
                portion of the Content. You may not scrape or otherwise copy our
                Content without written permission. You agree not to decompile,
                reverse engineer or disassemble any software or other products or
                processes accessible through the Web Site, or insert any code or
                product or manipulate the Content of myad360 or the Web Site in
                any way that affects the user’s experience, and not to use any
                data mining, data gathering or extraction method.
              </p>
              <p className="mt-4">
                In certain cases, you may be able to obtain a license to use
                individual stories that appear on the Web Site or affiliated
                myad360 Web Sites through online functionality we have
                specifically designated. For example, email a story to a friend or
                purchase a photograph.
              </p>

              <h4 className="text-[24px] font-bold text-[#0d0c1b]">
                Copyright Complaints
              </h4>
              <p>
                myad360 respects the intellectual property of others and holds no
                claim to copyrights of Content that is owned by a third party or
                is in the public domain. If you believe your work has been copied
                in a way that constitutes copyright infringement or you are aware
                of any infringing material on any of myad360 Web Sites, please
                provide to myad360 Copyright and Intellectual Property Agent the
                following information at mailto:info@myad360.com:
              </p>
              <ul className="mt-4 list-disc">
                <li>
                  an electronic or physical signature of the person authorized to
                  act on behalf of the owner of the copyright or other
                  intellectual property interest;
                </li>
                <li>
                  a description of the copyrighted work or other intellectual
                  property interest that is the subject of your claim;
                </li>
                <li>
                  a description of where the material is located on the Web Site;
                </li>
                <li>your address, telephone number, and e-mail address;</li>
                <li>
                  a statement by you that you have a good faith belief that access
                  to the relevant material through the Site is inappropriate;
                </li>
                <li>
                  a statement by you, made under penalty of perjury, that the
                  above information in your notice is accurate and that you are
                  the copyright or other intellectual property owner or authorized
                  to act on the copyright or other intellectual property owner’s
                  behalf.
                </li>
              </ul>
              <h4 className="text-[24px] font-bold text-[#0d0c1b]">
                Membership, Registration, Termination and Passwords
              </h4>
              <p>
                To use certain features of certain services provided by myad360,
                you must register on the form(s) provided. Once registered you
                will become a “Member” and will be considered to have “Membership”
                in the Web Site. If you become a Member of the myad360 Web Site,
                or any of its affiliated Web Sites or services, you accept
                responsibility for all activities that occur under your account
                and password, and agree not to sell, transfer or assign your
                Membership or any Membership rights.
              </p>
              <p className="mt-4">
                When registering, you agree to provide true, accurate, current and
                complete information about yourself as prompted by the Web Site’s
                registration form and to maintain and promptly update the
                information you provide to keep it true, accurate, current and
                complete. We reserve the right to terminate your Membership at any
                time for any reason and without notice. In the event of
                termination, you are no longer authorized to access the part of
                the Web Site affected by such cancellation or termination. The
                restrictions imposed on you with respect to material downloaded
                from any portion of the Web Site, and the disclaimers and
                limitations of liabilities set forth in these Terms of Use, shall
                survive.
              </p>
              <p className="mt-4">
                You are responsible for maintaining the confidentiality of your
                password and for restricting access to your computer so others
                outside your household may not access myad360 using your name in
                whole or in part without your permission. If you believe someone
                has accessed your member name and/or password without your
                authorization, e-mail us immediately. myad360 cannot and will not
                be liable for any loss or damage arising from your failure to
                protect your password or account information.
              </p>
              <h4 className="text-[24px] font-bold text-[#0d0c1b]">
                License to myad360
              </h4>
              <p>
                By posting a message, uploading a file, providing information to,
                communicating with, or otherwise placing any material on our Web
                Sites, you are granting myad360, an irrevocable, royalty-free,
                perpetual, non-exclusive, unrestricted right and license to use,
                copy, sublicense, modify, display, archive, store, distribute,
                reproduce and create derivative works from such information, in
                any form, media, software or technology or any kind now existing
                or
              </p>
              <p className="mt-4">
                developed in the future. Without limiting the generality of the
                previous term, you authorize myad360 and its affiliates to share
                the information across all myad360 locations, other myad360 Web
                Sites and to use your name and any other information in connection
                with its use of the material you provide. All such rights are
                granted without the requirement for additional compensation of any
                sort to you and without further permission required.
              </p>
              <h4 className="text-[24px] font-bold text-[#0d0c1b]">
                Interactive Features
              </h4>
              <p>
                Services offered by myad360 or any of its affiliates on any of its
                Web Sites may include a variety of features, such as message
                boards, photo galleries, comments and other interactive features
                which will allow feedback to myad360 and real-time interaction
                between users (collectively “Services”). These features are
                provided to give users an interesting and stimulating forum to
                express their opinions and share ideas and information. myad360
                cannot and does not monitor all of the material posted or
                transmitted by users and third party information providers.
              </p>
              <p className="mt-4">
                It is a condition of your use of these Services that you generally
                exercise your best judgment and specifically do not:
              </p>
              <ul className="mt-4 list-disc">
                <li>
                  Restrict or inhibit any other user(s) from using and enjoying
                  the Web Site.
                </li>
                <li>
                  Post any material that contains vulgar, profane, abusive,
                  hateful or racist language or expressions, text, photographs or
                  illustrations in poor taste, or attacks of a personal, racial or
                  religious nature.
                </li>
                <li>
                  Post any material that is threatening, false, defamatory,
                  misleading, fraudulent, unfair, and inaccurate, contains gross
                  exaggeration or unsubstantiated claims, violates the privacy
                  rights of any party, is unreasonably harmful or offensive to any
                  individual, community, association, business or group.
                </li>
                <li>
                  Violate any right of myad360 or any of its subsidiaries or
                  affiliates.
                </li>
                <li>
                  Post any material that discriminates, or refers to such matters
                  in any manner prohibited by law.
                </li>
                <li>
                  Disrupt, interfere with or otherwise harms or violates the
                  security of myad360, the Web Site or any services, resources,
                  passwords, servers or networks through myad360 or affiliated or
                  linked sites.
                </li>
                <li>
                  Post any material that contains or links to viruses or other
                  harmful, disruptive or destructive files.
                </li>
                <li>
                  Use or attempt to use another’s identity, account, password,
                  service or system except as expressly permitted by the Terms of
                  Use.
                </li>
                <li>
                  Post any material that includes copyrighted or other proprietary
                  material of any kind without express permission of the owner of
                  the material.
                </li>
                <li>
                  Post any material that includes advertisements, promotions, or
                  offers to trade any goods or services, except in areas
                  specifically designated for such purpose, if available.
                </li>
                <li>
                  Post any material that violates or encourages the violation of
                  any municipal, state, federal or international law, rule or
                  regulation.
                </li>
              </ul>
              <p className="mt-4">
                myad360 reserves the right to delete any communications at any
                time, for any reason or in its discretion, but has no obligation
                to review or remove any such content. myad360 also reserves the
                right to disclose any information as necessary to satisfy any law,
                regulation or governmental request, or to refuse to post or to
                remove any information or materials, in whole or in part, that in
                myad360’s sole discretion are objectionable or in violation of
                these Terms of Use.
              </p>

              <h4 className="text-[24px] font-bold text-[#0d0c1b]">
                Responsibility for the Content You Submit
              </h4>
              <p>
                You are fully responsible for any content you submit on our Web
                Site (which includes posting a message, uploading a file,
                providing information to, communicating with, or otherwise placing
                any material on the Web Site). You also understand that we are not
                responsible for any content you may submit on the Web Site. You
                also understand and certify that you have the permission of others
                who may have contributed to or are featured or depicted in any
                content you submit on the Web Site. If there are any individuals
                under the age of 18 in any photographs, videos, or images in the
                content you intend to submit on the Web Site you must obtain and
                you certify that you have obtained the permission of the parent or
                legal guardian of any such individual before submitting such
                content.
              </p>

              <h4 className="text-[24px] font-bold text-[#0d0c1b]">
                E-Commerce and Transactions on our Web Sites
              </h4>
              <p>
                myad360 may allow you to engage in a transaction involving the
                purchase of a product or service such as a newspaper subscription,
                a print or online
              </p>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default PrivacyPolicy;
